// sidebarItems.js
import { FiUsers } from 'react-icons/fi';
import { FaBed, FaPeopleCarry, FaTable, FaUserClock, FaUserNinja } from 'react-icons/fa';
import { GrBusinessService, GrUserPolice, GrVmMaintenance } from 'react-icons/gr';
import {
  MdOutlineBedroomParent,
  MdOutlineHelpOutline,
  MdOutlineDashboard,
  MdOutlineInventory,
  MdOutlineShoppingCart,
  MdOutlineDashboardCustomize,
  MdOutlineRoomService,
  MdOutlineBuild,
  MdOutlineFastfood,
  MdManageAccounts,
  MdOutlineAccountBalanceWallet,
  MdLanguage,
  MdCurrencyExchange,
  MdOutlineAccountBalance,
  MdOutlineManageAccounts,
  MdOutlineVerifiedUser,
  MdOutlineBedroomChild,
  MdOutlineCorporateFare,
} from 'react-icons/md';
import { TbCashRegister, TbDeviceDesktopSearch, TbReceiptTax, TbReportMoney } from 'react-icons/tb';
import { AiOutlineAudit } from 'react-icons/ai';
import {
  IoPricetagsOutline,
  IoFastFoodOutline,
  IoSettingsOutline,
  IoColorPaletteOutline,
  IoNotificationsOutline,
  IoFastFood,
} from 'react-icons/io5';
import { LuClipboardList } from 'react-icons/lu';
import { BsClipboardCheck, BsFileEarmarkBarGraph } from 'react-icons/bs';
import { HiOutlineDocumentReport, HiOutlineReceiptRefund } from 'react-icons/hi';
import { GrDatabase, GrConfigure } from 'react-icons/gr';
import { GiKeyring } from 'react-icons/gi';
import { BiFoodMenu } from 'react-icons/bi';
import { GrUserWorker } from 'react-icons/gr';
import { LiaFileContractSolid, LiaMoneyBillSolid, LiaSortAmountUpSolid } from 'react-icons/lia';
import { TiGroupOutline } from 'react-icons/ti';
import { RiSecurePaymentLine, RiUserSettingsLine } from 'react-icons/ri';
import { PiCashRegister, PiCertificate, PiInvoice } from 'react-icons/pi';
import { VscFeedback } from 'react-icons/vsc';
import { PiBuildingOfficeBold } from 'react-icons/pi';
import { CiSettings } from 'react-icons/ci';

export const primaryItems = [
  {
    name: 'Dashboard',
    icon: <MdOutlineDashboard className="h-6 w-6" />,
    path: '/dashboard',
    permission: 'Dashboard', // Define the permission required
  },
  {
    name: 'Master Data Management',
    icon: <GrDatabase className="h-6 w-6" />,
    path: '/dashboard/mdm/property-management',
    permission: 'Master Data Management', // Define the permission required
    subItems: [
      {
        name: 'Property Management',
        path: '/dashboard/mdm/property-management',
        icon: <GiKeyring className="h-5 w-5" />,
        permission: 'Property Management', // Define the permission required
      },
      {
        name: 'Room Management',
        path: '/dashboard/mdm/room-management/overview',
        icon: <MdOutlineBedroomParent className="h-5 w-5" />,
        permission: 'Room Management', // Define the permission required
        subItems: [
          {
            name: 'Overview',
            path: '/dashboard/mdm/room-management/overview',
            icon: <MdOutlineDashboardCustomize className="h-4 w-4" />,
            permission: 'Overview', // Define the permission required
          },
          {
            name: 'Room Management',
            path: '/dashboard/mdm/room-management/rooms',
            icon: <MdOutlineBedroomParent className="h-4 w-4" />,
            permission: 'Room management', // Define the permission required
          },
          // {
          //   name: "Order Summary",
          //   path: "/dashboard/mdm/room-management/order-summary",
          //   icon: <MdOutlineShoppingCart className="h-5 w-5" />,
          //   permission: "Master Data Management", // Define the permission required
          // },
        ],
      },
      {
        name: 'Amenities Management',
        path: '/dashboard/mdm/amenities-management/room-service',
        icon: <MdOutlineDashboardCustomize className="h-5 w-5" />,
        permission: 'Amenities management', // Define the permission required
        subItems: [
          {
            name: 'Room Service',
            path: '/dashboard/mdm/amenities-management/room-service',
            icon: <MdOutlineRoomService className="h-4 w-4" />,
            permission: 'Room service', // Define the permission required
          },
          {
            name: 'Amenities',
            path: '/dashboard/mdm/amenities-management/amenities',
            icon: <MdOutlineBuild className="h-4 w-4" />,
            permission: 'Amenities management', // Define the permission required
          },
        ],
      },
      {
        name: 'Menu Management',
        path: '/dashboard/mdm/menu-items-managment',
        icon: <BiFoodMenu className="h-5 w-5" />,
        permission: 'Menu management', // Define the permission required
        subItems: [
          {
            name: 'Items Management',
            path: '/dashboard/mdm/menu-items-managment',
            icon: <MdOutlineRoomService className="h-4 w-4" />,
            permission: 'Menu management', // Define the permission required
          },
          {
            name: 'Menu Categorization',
            path: '/dashboard/mdm/menu-Categorization',
            icon: <MdOutlineBuild className="h-4 w-4" />,
            permission: 'Menu Categorization', // Define the permission required
          },
          {
            name: 'Pricing & Promotions',
            path: '/dashboard/mdm/menu-pricing-promotions',
            icon: <MdOutlineFastfood className="h-4 w-4" />,
            permission: 'Pricing & Promotions', // Define the permission required
          },
          {
            name: 'Analytics & Insights',
            path: '/dashboard/mdm/menu-analytics-insights',
            icon: <MdOutlineFastfood className="h-4 w-4" />,
            permission: 'Analytics & Insights', // Define the permission required
          },
        ],
      },
      {
        name: 'User Management',
        icon: <FiUsers className="h-5 w-5" />,
        path: '/dashboard/mdm/users',
        permission: 'User Management',
      },
      // {
      //   name: "Vendor Management",
      //   icon: <TiGroupOutline className="h-5 w-5" />,
      //   path: "/dashboard/mdm/vendor-management",
      //   permission: "Master Data Management",
      //    subItems: [
      //     {
      //       name: "Overview",
      //       path: "/dashboard/mdm/vendor-management",
      //       icon: <BsFileEarmarkBarGraph className="h-5 w-5" />,
      //       permission: "Master Data Management", // Define the permission required
      //     },
      //     {
      //       name: "Vendor Accounts",
      //       path: "/dashboard/mdm/vendor-management/accounts",
      //       icon: <MdOutlineManageAccounts  className="h-5 w-5" />,
      //       permission: "Master Data Management", // Define the permission required
      //     },
      // {
      //   name: "Purchase Orders",
      //   path: "/dashboard/mdm/vendor-management/purchase-orders",
      //   icon: <MdOutlineManageAccounts  className="h-5 w-5" />,
      //   permission: "Master Data Management", // Define the permission required
      // },
      // {
      //   name: "Payments",
      //   path: "/dashboard/mdm/vendor-management/payments",
      //   icon: <LiaFileContractSolid className="h-5 w-5" />,
      //   permission: "Master Data Management", // Define the permission required
      // },
      //   ],
      // },
      // {
      //   name: "Inventory Management",
      //   icon: <MdOutlineInventory  className="h-5 w-5" />,
      //   path: "/dashboard/mdm/inventory-management",
      //   permission: "Master Data Management",
      // },
      {
        name: 'Customer Management',
        path: '/dashboard/mdm/customer-management/corporate-overview',
        icon: <PiBuildingOfficeBold className="h-5 w-5" />,
        permission: 'Customer management', // Define the permission required
        subItems: [
          {
            name: 'Overview',
            path: '/dashboard/mdm/customer-management/corporate-overview',
            icon: <BsFileEarmarkBarGraph className="h-5 w-5" />,
            permission: 'Customer management', // Define the permission required
          },
          {
            name: 'Guest Accounts',
            path: '/dashboard/mdm/customer-management/leisure',
            icon: <MdOutlineManageAccounts className="h-5 w-5" />,
            permission: 'Leisure Accounts', // Define the permission required
          },
          {
            name: 'Corporate Accounts',
            path: '/dashboard/mdm/customer-management/corporate',
            icon: <MdOutlineCorporateFare className="h-5 w-5" />,
            permission: 'Corporate Accounts', // Define the permission required
          },
          {
            name: 'Contracts',
            path: '/dashboard/mdm/customer-management/contracts',
            icon: <LiaFileContractSolid className="h-5 w-5" />,
            permission: 'Contracts', // Define the permission required
          },
          {
            name: 'Credit & Verification',
            path: '/dashboard/mdm/customer-management/credit-verification',
            icon: <MdOutlineVerifiedUser className="h-5 w-5" />,
            permission: 'Credit & Verification', // Define the permission required
          },
          {
            name: 'Settings',
            path: '/dashboard/mdm/customer-management/settings',
            icon: <CiSettings className="h-5 w-5" />,
            permission: 'Settings', // Define the permission required
          },
        ],
      },
    ],
  },

  {
    name: 'Core Modules',
    icon: <MdOutlineInventory className="h-6 w-6" />,
    path: '/dashboard/core-modules',
    permission: 'Core Modules', // Define the permission required
    subItems: [
      {
        name: 'Property Management',
        path: '/dashboard/core-modules/property-management-system/front-desk-operations',
        icon: <GiKeyring className="h-5 w-5" />,
        permission: 'Property management', // Define the permission required
        subItems: [
          // {
          //   name: "Reservations & Booking",
          //   path: "/dashboard/core-modules/property-management-system",
          //   icon: <IoPricetagsOutline className="h-4 w-4" />,
          //   permission: "Core Modules", // Define the permission required
          // },
          {
            name: 'Front Desk Operations',
            path: '/dashboard/core-modules/property-management-system/front-desk-operations',
            icon: <BsClipboardCheck className="h-4 w-4" />,
            permission: 'Front Desk Operations', // Define the permission required
          },
          {
            name: 'Guest Management',
            path: '/dashboard/core-modules/property-management-system/guest-managment',
            icon: <LuClipboardList className="h-4 w-4" />,
            permission: 'Guest Management', // Define the permission required
          },
          {
            name: 'Hospitality Services',
            path: '/dashboard/core-modules/property-management-system/front-desk-roomservices',
            icon: <BsClipboardCheck className="h-4 w-4" />,
            permission: 'Hospitality Services', // Define the permission required
          },
          {
            name: ' Facility Services',
            path: '/dashboard/core-modules/property-management-system/front-desk-amenities',
            icon: <TbCashRegister className="h-4 w-4" />,
            permission: 'Facility Services', // Define the permission required
          },
          {
            name: 'Billing & Payments',
            path: '/dashboard/core-modules/property-management-system/billing-payments',
            icon: <MdOutlineShoppingCart className="h-4 w-4" />,
            permission: 'Billing & Payments', // Define the permission required
          },
          {
            name: 'Refunds & Adjustments',
            path: '/dashboard/core-modules/property-management-system/refunds-adjustments',
            icon: <HiOutlineReceiptRefund className="h-4 w-4" />,
            permission: 'Billing & Payments', // Define the permission required
          },
        ],
      },
      {
        name: 'Financial Accounting',
        icon: <MdOutlineAccountBalanceWallet className="h-5 w-5" />,
        path: '/dashboard/core-modules/financial-accounting',
        permission: 'Financial Accounting',
        subItems: [
          {
            name: 'Billing & Invoicing',
            path: '/dashboard/core-modules/finance/billing-invoicing',
            icon: <PiCashRegister className="h-4 w-4" />,
            permission: 'Billing & Invoicing',
          },
          {
            name: 'Accounts',
            path: '/dashboard/core-modules/finance/accounts-receivable-payable',
            icon: <MdOutlineAccountBalance className="h-4 w-4" />,
            permission: 'Accounts',
          },
          {
            name: 'Financial Reporting',
            path: '/dashboard/core-modules/finance/financial-reporting',
            icon: <MdOutlineAccountBalanceWallet className="h-4 w-4" />,
            permission: 'Financial Reporting',
          },
          {
            name: 'Tax Management',
            path: '/dashboard/core-modules/finance/tax-management',
            icon: <GrBusinessService className="h-4 w-4" />,
            permission: 'Tax Management',
          },
          {
            name: 'Audit Logs',
            path: '/dashboard/core-modules/finance/audit-logs',
            icon: <AiOutlineAudit className="h-4 w-4" />,
            permission: 'Audit Logs',
          },
        ],
      },
      {
        name: 'Revenue Management',
        path: '/dashboard/core-modules/revenue-management',
        icon: <LiaSortAmountUpSolid className="h-5 w-5" />,
        permission: 'Revenue Management', // Define the permission required
        subItems: [
          {
            name: 'Overview',
            path: '/dashboard/core-modules/revenue-management/pricing-overview',
            icon: <IoPricetagsOutline className="h-4 w-4" />,
            permission: 'Pricing', // Define the permission required
          },
          {
            name: 'Template',
            path: '/dashboard/core-modules/revenue-management/pricing-template',
            icon: <BsClipboardCheck className="h-4 w-4" />,
            permission: 'Template', // Define the permission required
          },
          {
            name: 'Pricing Factors',
            path: '/dashboard/core-modules/revenue-management/modify-factors',
            icon: <LuClipboardList className="h-4 w-4" />,
            permission: 'Pricing Factors', // Define the permission required
          },
          {
            name: 'Pricing',
            path: '/dashboard/core-modules/revenue-management/pricing',
            icon: <BsClipboardCheck className="h-4 w-4" />,
            permission: 'pricing', // Define the permission required
          },
          {
            name: 'Room Rates',
            path: '/dashboard/core-modules/revenue-management/room-rates',
            icon: <TbCashRegister className="h-4 w-4" />,
            permission: 'Room Rates', // Define the permission required
          },
        ],
      },
      {
        name: 'Food & Beverages',
        path: '/dashboard/core-modules/f&b-management',
        icon: <IoFastFoodOutline className="h-5 w-5" />,
        permission: 'Food & Beverages', // Define the permission required
        subItems: [
          {
            name: 'Orders',
            path: '/dashboard/core-modules/f&b-management/track-order-frontdesk',
            icon: <IoPricetagsOutline className="h-4 w-4" />,
            permission: 'Orders', // Define the permission required
          },
          {
            name: 'Order Food',
            path: '/dashboard/core-modules/f&b-management/order-food',
            icon: <IoFastFoodOutline className="h-4 w-4" />,
            permission: 'Order Food', // Define the permission required
          },
          {
            name: 'Dining Tables',
            path: '/dashboard/core-modules/f&b-management/dining-tables',
            icon: <FaTable className="h-4 w-4" />,
            permission: 'Order Processing Panel', // Define the permission required
          },
          {
            name: 'KDS',
            path: '/dashboard/core-modules/f&b-management/track-order-kitchen',
            icon: <BsClipboardCheck className="h-4 w-4" />,
            permission: 'Order Processing Panel', // Define the permission required
          },
          {
            name: 'Billing & Invoicing',
            path: '/dashboard/core-modules/f&b-management/order-invoicing',
            icon: <PiInvoice className="h-4 w-4" />,
            permission: 'Order Processing Panel', // Define the permission required
          },
        ],
      },
      {
        name: 'Feedback & Queries',
        path: '/dashboard/core-modules/feedback&queries/feedback-management',
        icon: <VscFeedback className="h-5 w-5" />,
        permission: 'Feedback & Queries', // Define the permission required
        subItems: [
          {
            name: 'Feedback Mgmt.',
            path: '/dashboard/core-modules/feedback&queries/feedback-management',
            icon: <MdOutlineBedroomParent className="h-4 w-4" />,
            permission: 'Feedback Management', // Define the permission required
          },
          {
            name: 'Queries Mgmt.',
            path: '/dashboard/core-modules/feedback&queries/queries-management',
            icon: <TbDeviceDesktopSearch className="h-4 w-4" />,
            permission: 'Queries Management', // Define the permission required
          },
        ],
      },
      // {
      //   name: "Online Booking Engine",
      //   icon: <MdFamilyRestroom className="h-5 w-5" />,
      //   path: "/dashboard/core-modules/online-booking-engine",
      //   permission: "Core Modules",
      //   subItems: [
      //     {
      //       name: "Direct Booking Integration",
      //       path: "/dashboard/core-modules/online-booking-engine",
      //       icon: < MdOutlineBedroomParent className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Channel Management",
      //       path: "/dashboard/core-modules/online-booking-engine/channel-management",
      //       icon: <TbDeviceDesktopSearch   className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Payment Gateway",
      //       path: "/dashboard/core-modules/online-booking-engine/payment-gateway",
      //       icon: <MdPayment  className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //   ],
      // },
      // {
      //   name: "Point Of Sale",
      //   path: "/dashboard/core-modules/pos/restaurant-bar-billing",
      //   icon: <MdOutlinePointOfSale className="h-5 w-5" />,
      //   permission: "Core Modules",
      //   subItems: [
      //     {
      //       name: "Restaurant & Bar Billing",
      //       path: "/dashboard/core-modules/pos/restaurant-bar-billing",
      //       icon: <MdOutlineTableBar className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Retail Point of Sale",
      //       path: "/dashboard/core-modules/pos/retail-pos",
      //       icon: <PiCashRegister  className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //   ],
      // },
      // {
      //   name: "Event & Banquet",
      //   icon: <MdOutlineShoppingCart className="h-5 w-5" />,
      //   path: "/dashboard/core-modules/event-banquet-management",
      //   permission: "Core Modules",
      //   subItems: [
      //     {
      //       name: "Event Planning",
      //       path: "/dashboard/core-modules/banquet-management/event-planning",
      //       icon: <MdEventAvailable className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Room Layout & Capacity",
      //       path: "/dashboard/core-modules/banquet-management/room-layout-capacity",
      //       icon: <MdReduceCapacity  className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Billing for Events",
      //       path: "/dashboard/core-modules/banquet-management/event-billing",
      //       icon: <LiaMoneyBillSolid  className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //   ],
      // },
      // {
      //   name: "Supplychain & Procurement",
      //   icon: <HiOutlineDocumentReport className="h-5 w-5" />,
      //   path: "/dashboard/core-modules/supplychain-procurement",
      //   permission: "Core Modules",
      //   subItems: [
      //     {
      //       name: "Vendor Management",
      //       path: "/dashboard/core-modules/supply-chain/vendor-management",
      //       icon: <FaUserNinja className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Inventory & Procurement",
      //       path: "/dashboard/core-modules/supply-chain/inventory-procurement",
      //       icon: <MdOutlineInventory2  className="h-5 w-5" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Cost Control & Budgeting",
      //       path: "/dashboard/core-modules/supply-chain/cost-control-budgeting",
      //       icon: <LiaMoneyBillSolid  className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //   ],
      // },
      // {
      //   name: "Human Resource Mgmt.",
      //   icon: <FaPeopleCarry className="h-5 w-5" />,
      //   path: "/dashboard/core-modules/hr",
      //   permission: "Core Modules",
      //   subItems: [
      //     {
      //       name: "Staff Scheduling",
      //       path: "/dashboard/core-modules/hrm/staff-scheduling",
      //       icon: <FaUserClock className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Payroll Management",
      //       path: "/dashboard/core-modules/hrm/payroll-management",
      //       icon: <RiSecurePaymentLine   className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Employee Certification",
      //       path: "/dashboard/core-modules/hrm/employee-training",
      //       icon: <PiCertificate   className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //   ],
      // },

      // {
      //   name: "Housekeeping Mgmt.",
      //   icon: <MdOutlineCleaningServices className="h-5 w-5" />,
      //   path: "/dashboard/core-modules/housekeeping-management",
      //   permission: "Core Modules",
      //   subItems: [
      //     {
      //       name: "Room Status & Cleaning",
      //       path: "/dashboard/core-modules/housekeeping-management",
      //       icon: <MdOutlineCleaningServices className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Maintenance Requests",
      //       path: "/dashboard/core-modules/housekeeping-management/maintenance-report",
      //       icon: <GrVmMaintenance  className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //     {
      //       name: "Inventory Management",
      //       path: "/dashboard/core-modules/housekeeping-management/inventory-management",
      //       icon: <MdOutlineInventory2   className="h-4 w-4" />,
      //       permission: "Core Modules", // Define the permission required
      //     },
      //   ],
      // },
    ],
  },

  {
    name: 'Reports & Analytics',
    icon: <GrBusinessService className="h-5 w-5" />,
    path: '/dashboard/reports/gst-reports',
    permission: 'Reports & Analytics', // Define the permission required
    subItems: [
      {
        name: 'GST Report',
        path: '/dashboard/reports/gst-reports',
        icon: <TbReceiptTax className="h-5 w-5" />,
        permission: 'GST Reports', // Define the permission required
      },
      {
        name: 'Police Verification Report',
        path: '/dashboard/reports/police-verification-reports',
        icon: <GrUserPolice className="h-5 w-5" />,
        permission: 'Police Verification Reports', // Define the permission required
      },
      {
        name: 'Revenue Report',
        path: '/dashboard/reports/revenue-reports',
        icon: <TbReportMoney className="h-5 w-5" />,
        permission: 'Revenue Reports', // Define the permission required
      },
      {
        name: 'Room Occupancy Report',
        path: '/dashboard/reports/room-occupancy-reports',
        icon: <MdOutlineBedroomChild className="h-5 w-5" />,
        permission: 'Room Occupancy Reports', // Define the permission required
      },
      {
        name: 'Restaurant Report',
        path: '/dashboard/reports/restaurant-reports',
        icon: <IoFastFood className="h-5 w-5" />,
        permission: 'Restaurant Reports', // Define the permission required
      },
    ],
  },
  {
    name: 'Help',
    icon: <MdOutlineHelpOutline className="h-6 w-6" />,
    path: '/dashboard/help',
    permission: 'Help', // Define the permission required
  },
  {
    name: 'System Configurations',
    icon: <IoSettingsOutline className="h-6 w-6" />,
    path: '/dashboard/system-config/wide-settings',
    permission: 'System Configurations', // Define the permission required
    subItems: [
      {
        name: 'Application-Wide Settings',
        path: '/dashboard/system-config/wide-settings',
        icon: <MdManageAccounts className="h-5 w-5" />,
        permission: 'System Configurations', // Define the permission required
        subItems: [
          {
            name: 'General',
            path: '/dashboard/system-config/wide-settings',
            icon: <RiUserSettingsLine className="h-4 w-4" />,
            permission: 'System Configurations', // Define the permission required
          },
          {
            name: 'Preferences',
            path: '/dashboard/system-config/preferences',
            icon: <IoColorPaletteOutline className="h-5 w-5" />,
            permission: 'System Configurations', // Define the permission required
          },
          {
            name: 'Notifications',
            path: '/dashboard/system-config/notifications',
            icon: <IoNotificationsOutline className="h-4 w-4" />,
            permission: 'System Configurations', // Define the permission required
          },
          {
            name: 'Language',
            path: '/dashboard/system-config/language',
            icon: <MdLanguage className="h-4 w-4" />,
            permission: 'System Configurations', // Define the permission required
          },
          {
            name: 'Currency',
            path: '/dashboard/system-config/currency',
            icon: <MdCurrencyExchange className="h-4 w-4" />,
            permission: 'System Configurations', // Define the permission required
          },
          {
            name: 'Hotel Configuration',
            path: '/dashboard/system-config/hotel-config',
            icon: <GrConfigure className="h-4 w-4" />,
            permission: 'System Configurations', // Define the permission required
          },
        ],
      },
    ],
  },
];
